import { render, staticRenderFns } from "./extrato-familia.vue?vue&type=template&id=62d06543&scoped=true"
import script from "./extrato-familia.vue?vue&type=script&lang=js"
export * from "./extrato-familia.vue?vue&type=script&lang=js"
import style0 from "./extrato-familia.vue?vue&type=style&index=0&id=62d06543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d06543",
  null
  
)

export default component.exports